import React from 'react';

export interface IContentBox {
  widthPct: number;
  heightPct: number;
  children: any;
  padding?: number;
  borderColor?: string;
}

const ContentBox = (props: IContentBox) => {
  const { widthPct, heightPct, children, padding, borderColor } = props;
  return (
    <div
      style={{
        width: `${widthPct}%`,
        height: `${heightPct}vh`,
        padding: padding,
        border: `2px solid ${borderColor ? borderColor : 'grey'}`,
        borderRadius: 10,
        overflowY: 'auto',
        boxShadow:
          '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
      }}
    >
      {children}
    </div>
  );
};

export default ContentBox;
